import { useTranslation } from 'react-i18next';
import type { PAGE_POSITIONS } from 'types';
import type { Affiliate, Price } from 'types/capi/shared';
import type { TrackableProduct } from 'types/TrackableProduct';

import AffiliateProductLink from '~/components/AffiliateProductLink';
import { sizeSixVariants } from '~/domain/sizes';
import type { UrlTemplates } from '~/utils/tracking';

function isSelectedSize(selectedSize: string | undefined, size: string) {
  if (!selectedSize) return false;

  if (selectedSize === '6') return sizeSixVariants.some((s) => s === size);

  return selectedSize === size;
}

type Props = {
  affiliate: Affiliate;
  disableClickThrough?: boolean;
  pagePosition: PAGE_POSITIONS;
  position: number;
  price: Price;
  product: TrackableProduct;
  selectedSize?: string;
  sizes: string[];
  urlTemplates: UrlTemplates;
};

const Size = ({
  isHighlighted,
  children
}: {
  children: string;
  isHighlighted: boolean;
}) => {
  return (
    <li
      className={`h-5 rounded-[40px] border border-grey-divide px-2 ${
        isHighlighted ? 'bg-black text-white' : 'bg-white text-grey-hide'
      }`}
    >
      {children}
    </li>
  );
};

const AffiliateSizes = ({
  sizes,
  selectedSize,
  pagePosition,
  position,
  disableClickThrough,
  affiliate,
  product,
  price,
  urlTemplates
}: Props) => {
  const { t } = useTranslation('pdp');

  if (!sizes.length) return null;

  return (
    <ul className="flex	flex-wrap gap-1 text-xs" data-cy="stock-listing-sizes">
      <li className="text-grey-hide">{t('sizesInStock')}:</li>
      {sizes.map((size) => (
        <AffiliateProductLink
          key={`sl-size-${size}`}
          price={price}
          affiliate={affiliate}
          product={product}
          buttonPosition={position}
          disableClickThrough={disableClickThrough}
          pagePosition={pagePosition}
          urlTemplates={urlTemplates}
          selectedSize={size}
          variant="none"
        >
          <Size isHighlighted={isSelectedSize(selectedSize, size)}>{size}</Size>
        </AffiliateProductLink>
      ))}
    </ul>
  );
};

export default AffiliateSizes;
